import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'motion/react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const AboutSection = () => {
  const [content, setContent] = useState<any>({
    homeAboutText: 'A UNIFIG – União dos Deficientes Físicos de Iguatemi é uma entidade civil privada sem fins lucrativos que nasceu do sonho de oferecer dignidade e reabilitação para pessoas com deficiência.'
  });

  useEffect(() => {
    const fetchContent = async () => {
      if (!db) return;
      try {
        const docRef = doc(db, 'content', 'pages');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContent(docSnap.data());
        }
      } catch (error) {
        console.error("Error fetching about content:", error);
      }
    };
    fetchContent();
  }, []);

  const highlights = [
    "Fundada em 14/11/2002",
    "Utilidade Pública Lei nº 980/2002",
    "Atendimento 100% Gratuito",
    "Equipe Multidisciplinar Especializada"
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://i.postimg.cc/DwDHJG5Z/Whats-App-Image-2026-03-11-at-16-07-16.jpg"
                alt="Sobre o Projeto"
                className="w-full h-auto object-cover"
                referrerPolicy="no-referrer"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-primary rounded-3xl -z-10"></div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-slate-100 rounded-full -z-10"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <div className="space-y-4">
              <h2 className="text-primary font-bold uppercase tracking-widest text-sm">Sobre a UNIFIG</h2>
              <h3 className="text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
                Nossa Missão é <span className="text-primary">Transformar Vidas</span>.
              </h3>
            </div>

            <p className="text-slate-600 text-lg leading-relaxed">
              {content.homeAboutText}
            </p>

            <p className="text-slate-600 text-lg leading-relaxed">
              Com uma sede totalmente adaptada e uma equipe técnica dedicada, realizamos mais de 16 mil atendimentos anuais, abrangendo desde a fisioterapia convencional até a equoterapia.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle2 className="text-primary shrink-0" size={20} />
                  <span className="text-slate-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <div className="p-6 bg-slate-50 rounded-2xl border border-slate-100 text-center">
                <p className="text-slate-900 font-bold text-lg">Edson Palla</p>
                <p className="text-slate-500 text-sm">Presidente Atual</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
